import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { LOAD_CART_REQUEST, LOAD_CART_SUCCESS, LOAD_CART_ERROR } from '../types';
import { forgetCart } from './forget-cart';
export var loadCartRequest = function loadCartRequest() {
  return {
    type: LOAD_CART_REQUEST
  };
};
export var loadCartSuccess = function loadCartSuccess(cart) {
  return {
    type: LOAD_CART_SUCCESS,
    data: cart
  };
};
export var loadCartError = function loadCartError(error) {
  return {
    type: LOAD_CART_ERROR,
    error: true,
    payload: error
  };
};
export var loadCart = function loadCart() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState, _ref) {
      var chord, createOrLoadCart, _getState, cart, auth, newCart;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            chord = _ref.chord;
            createOrLoadCart = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cartData, authToken) {
                var cart;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      if (cartData.number) {
                        _context.next = 2;
                        break;
                      }
                      return _context.abrupt("return", chord.oms.createOrder(authToken));
                    case 2:
                      _context.prev = 2;
                      _context.next = 5;
                      return chord.oms.getOrder(cartData);
                    case 5:
                      cart = _context.sent;
                      if (!(cart.state === 'complete')) {
                        _context.next = 9;
                        break;
                      }
                      dispatch(forgetCart());
                      return _context.abrupt("return", chord.oms.createOrder(authToken));
                    case 9:
                      return _context.abrupt("return", cart);
                    case 12:
                      _context.prev = 12;
                      _context.t0 = _context["catch"](2);
                      if (!(_context.t0.status !== 401)) {
                        _context.next = 16;
                        break;
                      }
                      throw _context.t0;
                    case 16:
                      // if the cart token or number stored in Redux/localStorage is invalid, clear and create a new order
                      dispatch(forgetCart());
                      return _context.abrupt("return", chord.oms.createOrder(authToken));
                    case 18:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[2, 12]]);
              }));
              return function createOrLoadCart(_x4, _x5) {
                return _ref3.apply(this, arguments);
              };
            }();
            _context2.prev = 2;
            _getState = getState(), cart = _getState.cart, auth = _getState.auth;
            dispatch(loadCartRequest());
            _context2.next = 7;
            return createOrLoadCart(cart.data, auth.token);
          case 7:
            newCart = _context2.sent;
            dispatch(loadCartSuccess(newCart));
            return _context2.abrupt("return", newCart);
          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](2);
            dispatch(loadCartError(_context2.t0));
            throw _context2.t0;
          case 16:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 12]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};